import { Trans, useLingui } from '@lingui/react/macro';

import IconValidation from '@/icons/Validation.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const ArticleQualityControlKONotification = ({
  notification,
}: {
  notification: TNotificationOfType<'article_quality_control_ko'>;
}) => {
  const { t } = useLingui();
  const { username } = notification.data;

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.article-quality-control-ko.label',
        message: `A quality issue has been detected by ${username} during the quality control process.`,
      })}
      icon={<IconValidation />}
      type="neutral"
      notification={notification}
      notificationHeader={() => (
        <Trans id="notification.article-quality-control-ko">
          A quality issue has been detected by {username} during the quality control process.
        </Trans>
      )}
    />
  );
};
